import type { SelectItem } from '@/components/Atoms/FaceliftSelect/FaceliftSelect.types';

export const statusOptions: SelectItem[] = [
	{ value: '953870000', label: 'Open' },
	// { value: '953870001', label: 'Shipped' },
	// { value: '953870002', label: 'Ready to Ship' },
	// { value: '953870003', label: 'Denied' },
];

/**
 * FedEx shipping method options for select dropdowns from crm
 */
export const shippingMethodItems: SelectItem[] = [
	{ value: '953870000', label: 'First Overnight (8:30 am)' },
	{ value: '953870001', label: 'Priority Overnight (10:30 am)' },
	{ value: '953870002', label: 'Standard Overnight (3:00 pm)' },
	{ value: '953870003', label: '2Day AM (10:30 am)' },
	{ value: '953870004', label: '2Day Standard (4:30 pm)' },
	{ value: '953870005', label: 'Null' },
];

/**
 * FedEx shipping method mapping (string keys) for lookups
 * Derived from shippingMethodItems to maintain single source of truth
 */
export const SHIPPING_METHOD_MAP_STRING: Record<string, string> = 
	shippingMethodItems.reduce((acc, item) => {
		acc[item.value] = item.label;
		return acc;
	}, {} as Record<string, string>);

/**
 * FedEx shipping method mapping (number keys) for lookups
 * Derived from shippingMethodItems to maintain single source of truth
 */
export const SHIPPING_METHOD_MAP_NUMBER: Record<number, string> = 
	shippingMethodItems.reduce((acc, item) => {
		acc[Number(item.value)] = item.label;
		return acc;
	}, {} as Record<number, string>);

